import { ReactNode } from "react";
import { Capacitor } from "@capacitor/core";

interface NativeStickyHeaderProps {
  children: ReactNode;
  /** Additional classes for the header content area */
  className?: string;
}

/**
 * Unified sticky header for all native app pages.
 * Only renders on native platforms (Capacitor).
 * On web, renders nothing — pages use their own web headers.
 *
 * Rules:
 * - position: sticky, top: 0, z-50
 * - opaque background (content must never be visible under the status bar)
 * - safe-area spacer above the 52px content row
 * - 1px bottom divider
 * - horizontal padding 16px
 */
export function NativeStickyHeader({ children, className }: NativeStickyHeaderProps) {
  if (!Capacitor.isNativePlatform()) return null;

  return (
    <header className="native-header sticky top-0 z-50 border-b border-border/60 bg-background">
      {/* Opaque safe-area spacer for notch / Dynamic Island */}
      <div
        className="bg-background"
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      />
      <div className={`flex h-[52px] items-center justify-between px-4 ${className || ""}`}>
        {children}
      </div>
    </header>
  );
}

export default NativeStickyHeader;
